export const LINK_ENTREGA = '/fichas-entrega';
export const LINK_INMATRICULACION_CORREO= '/venta/stock/inmatriculacion/envio-correo';
export const LINK_INMATRICULACION_CARGA_TITULO= '/venta/stock/inmatriculacion/carga-masiva';
export const LINK_FDV = '/fichas-venta';
export const LINK_LOGISTICA_ASIG = '/ficha-log-asignacion';
export const LINK_LOGISTICA_ETIQ = '/ficha-log-etiquetado';
export const LINK_LOGISTICA_INVE = '/ficha-log-inventario';
export const LINK_ENTREGA_LOGIS = '/fichas-entrega-logistica';
export const LINK_PROFORMA_FDV = '/venta/proforma/registro/ficha-venta';

export const LINK_BANDEJA_ACT ='/bandeja-actividades';

export const FDV_URL = process.env.REACT_APP_SID_FICHA_VENTA;
export const GENERIC_URL = process.env.REACT_APP_SID_GENERICO;
export const FE_URL = process.env.REACT_APP_SID_FE;
export const PROFORMA_URL = process.env.REACT_APP_SID_PROFORMA;
export const STOCK_URL = process.env.REACT_APP_SID_STOCK;
export const ENTREGAS_URL = process.env.REACT_APP_SID_ENTREGAS;
export const LOGISTICA_URL = process.env.REACT_APP_SID_LOGISTICA;
export const SEGURIDAD_URL = process.env.REACT_APP_SID_SEGURIDAD;
export const LOGIN_URL = process.env.REACT_APP_SID_LOGIN;
export const LOCAL_URL = process.env.REACT_APP_SID_LOCAL;



// WEBPACK FOOTER //
// ./src/constants/routes.js